import React from "react";
import { Skeleton } from "antd";
import Settings from "components/settings";
import { Localize } from "components/service";


const renderPrice = Settings.Helpers.TranslationAiTable.renderPrice;
const renderNumber = Settings.Helpers.TranslationAiTable.renderNumber;

const summaryItems = [
    {
        label: 'TABLES.Column_Title_TotalPrice',
        key: 'total_tokens_price',
        isPrice: true,
    },
    {
        label: 'TABLES.Column_Title_Items',
        key: 'items_count',
    },
    {
        label: 'TABLES.Column_Title_TotalTokens',
        key: 'total_tokens',
    },
    {
        label: 'TABLES.Column_Title_Requests',
        key: 'requests_count',
    },
];

const TranslationAiTotalSummary = ({ total, loading }) => (
    <div className="translation-ai-summary">
        { summaryItems.map(({ label, key, isPrice }) => (
            <div className="translation-ai-summary-item" key={ key }>
                <span className="label-text"><Localize>{ label }</Localize></span>
                <strong>
                    { loading ?
                        <Skeleton.Input active size="small" /> :
                        isPrice ? renderPrice(total?.[ key ]) : renderNumber(total?.[ key ])
                    }
                </strong>
            </div>
        )) }
    </div>
);

export default TranslationAiTotalSummary;
